import { BaseField } from "components/Form/BaseField";
import SelectWithFilter from "components/SelectWithFilter/SelectWithFilter";
import { translate, SelectOption } from "@shape/reef-shared";
import { useEffect, useState } from "react";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import styles from "../NewStep1Initiation.module.scss";

export interface TeamMemberProps<TFieldValues extends FieldValues> {
  readonly title?: string;
  readonly name: FieldPath<TFieldValues>;
  readonly options: SelectOption[];
  readonly form: UseFormReturn<TFieldValues>;
  onFilterChange: (currentFilter: string) => void;
  readonly readOnly: boolean;
  readonly subtitle?: string;
  readonly defaultValue?: {
    userId: number;
    mail: string;
  };
  readonly isLoadingUsers?: boolean;
  readonly maxResults?: number;
}

export function TeamMember<TFieldValues extends FieldValues>({
  title,
  name,
  subtitle,
  defaultValue,
  form,
  options,
  onFilterChange,
  readOnly,
  isLoadingUsers,
  maxResults,
}: TeamMemberProps<TFieldValues>) {
  const [data, setData] = useState<SelectOption>();
  const setDefaultValue = () => {
    const newData: SelectOption = {
      id: defaultValue?.userId ?? "",
      label: defaultValue?.mail ?? "",
    };
    setData(newData);
  };

  useEffect(() => {
    setDefaultValue();
  }, []);

  return (
    <div className={styles.row} key={title}>
      <div className={styles.teamMemberContainer}>
        <div>
          <h4 className={styles.teamMemberField}>
            <div className={styles.teamMemberLabel}>{title}</div>
            <div> {subtitle && <h6>{subtitle}</h6>}</div>
          </h4>
          <BaseField
            form={form}
            name={name}
            label={translate("formGeneric.nameOrEmail")}
            rules={{ required: true }}
            defaultValue={defaultValue?.userId}
            render={({ field }) => (
              <div
                className={styles.teamMemberSelect}
                key={`assessment_team-${defaultValue?.userId}`}
              >
                {readOnly ? (
                  <div>{data?.label}</div>
                ) : (
                  <SelectWithFilter
                    readOnly={readOnly}
                    onFilterChange={onFilterChange}
                    options={options}
                    maxResults={maxResults}
                    placeholder={translate("formGeneric.typeNameOrEmail")}
                    isLoading={isLoadingUsers}
                    selectedValue={field.value}
                    onChange={field.onChange}
                  />
                )}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
}
